import { locale, messages } from 'i18n'

// Reducer
const INITIAL_STATE = {
  locale: locale,
  messages: messages[locale],
}

export function reducer(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    default:
      return state
  }
}

export const selectLocale = (state) => state.intl.locale
